import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

export default function Footer() {
  return (
    <footer style={{ background: '#0D1B2A', color: 'white' }}>
      <div style={{ borderBottom: '1px solid rgba(255,255,255,0.08)', padding: '4rem 0' }}>
        <div className="container">
          <div style={{ display: 'grid', gridTemplateColumns: '1.5fr 1fr 1fr 1fr', gap: '3rem' }} className="footer-grid">
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', marginBottom: '1.2rem' }}>
                <motion.span animate={{ rotate: 360 }} transition={{ duration: 12, repeat: Infinity, ease: 'linear' }} style={{ fontSize: '1.8rem' }}>⚙️</motion.span>
                <div style={{ fontFamily: 'var(--font-display)', fontSize: '1.3rem', letterSpacing: '2px' }}>
                  ELIM<span style={{ color: 'var(--orange)' }}>DEPANNAGE</span>
                </div>
              </div>
              <p style={{ fontSize: '0.9rem', color: 'rgba(255,255,255,0.5)', lineHeight: 1.7, marginBottom: '1.5rem' }}>
                La plateforme qui connecte les mécaniciens professionnels aux clients partout au Bénin.
              </p>
              <div style={{ display: 'flex', gap: '0.8rem' }}>
{[].map((icon, i) => (                  <a key={i} href="#" style={{
                    width: '38px', height: '38px', background: 'rgba(255,255,255,0.07)',
                    borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center',
                    transition: 'all 0.2s', fontSize: '1.1rem', border: '1px solid rgba(255,255,255,0.1)',
                  }}>{icon}</a>
                ))}
              </div>
            </div>

            {[
              { title: 'Services', links: [['Mécanique Moto', '/prestataires?service=MECANIQUE_MOTO'], ['Mécanique Voiture', '/prestataires?service=MECANIQUE_VOITURE'], ['Vulcanisateur', '/prestataires?service=VULCANISATEUR'], ['Électricité Auto', '/prestataires?service=ELECTRICITE_AUTO'], ['Carrosserie', '/prestataires?service=CARROSSERIE']] },
              { title: 'Plateforme', links: [['Comment ça marche', '/comment-ca-marche'], ['Tous les prestataires', '/prestataires'], ['Devenir prestataire', '/inscription?type=prestataire'], ['Contact', '/contact']] },
              { title: 'Légal', links: [["Conditions d'utilisation", '/conditions'], ['Confidentialité', '/confidentialite'], ['FAQ', '/faq']] },
            ].map((col, i) => (
              <div key={i}>
                <h4 style={{ fontFamily: 'var(--font-cond)', fontSize: '0.75rem', fontWeight: 700, letterSpacing: '3px', textTransform: 'uppercase', color: 'var(--orange)', marginBottom: '1.5rem' }}>
                  {col.title}
                </h4>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.7rem' }}>
                  {col.links.map(([label, to]) => (
                    <Link key={label} to={to} style={{ fontSize: '0.88rem', color: 'rgba(255,255,255,0.5)' }}>{label}</Link>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div style={{ padding: '1.5rem 0', textAlign: 'center' }}>
        <p style={{ fontSize: '0.85rem', color: 'rgba(255,255,255,0.3)' }}>
          © {new Date().getFullYear()} ELIM DEPANNAGE. Tous droits réservés. 🇧🇯
        </p>
      </div>
      <style>{`
        @media (max-width: 900px) { .footer-grid { grid-template-columns: 1fr 1fr !important; gap: 2rem !important; } }
        @media (max-width: 600px) { .footer-grid { grid-template-columns: 1fr !important; } }
      `}</style>
    </footer>
  );
}
